
<div class="row" style="margin-top: 150px; ">
    <div class="col-md-6 offset-md-3">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">RegScale - Login</h4>
          <p class="category">Admininstrative Access for Managing RegScale.com</p>
        </div>
        <div class="card-body">
          <p class="mb-4">NOTE: This functionality is only available to RegScale personnel.  You must have valid Active Directory (AD) credentials to login.</p>
          <button *ngIf="!user" (click)="login()" class="btn btn-primary btn-round">Login</button>
          <h3 *ngIf="user"><i class="fas fa-user-circle mr-2"></i>{{ user.displayName }}</h3><br/>
          <button *ngIf="user" (click)="dashboard()" class="btn btn-primary btn-round mr-2 mt-3">Go to Dashboard</button>
          <button *ngIf="user" (click)="logout()" class="btn btn-danger btn-round mt-3">Logout</button>
        </div>
      </div>
    </div>